module.exports = __webpack_public_path__ + "static/img/module3.d2fdc344.jpg";